import { useState, type CSSProperties, type ReactElement } from 'react';
import styles from './palmares-podium-filter.module.scss';
import { Icon } from '@utmb/design-system/icons/Icon';
import { IconsEnum } from '@utmb/types/icons';

export type PodiumFilterValue = number[];

export interface PalmaresPodiumFilterProps {
    value?: PodiumFilterValue;
    onChange?: (value: PodiumFilterValue) => void;
}

const ENTRIES: Array<{ value: 1 | 2 | 3; icon: IconsEnum; glow: string }> = [
    { value: 1, icon: IconsEnum.TOP1, glow: 'var(--utmb-color-rank-1)' },
    { value: 2, icon: IconsEnum.TOP2, glow: 'var(--utmb-color-rank-2)' },
    { value: 3, icon: IconsEnum.TOP3, glow: 'var(--utmb-color-rank-3)' },
];

export function PalmaresPodiumFilter({ value, onChange }: PalmaresPodiumFilterProps): ReactElement {
    const [internal, setInternal] = useState<PodiumFilterValue>(value ?? []);
    const selection = value !== undefined ? value : internal;

    function handleClick(next: number) {
        const resolved = selection.includes(next) ? selection.filter((v) => v !== next) : [...selection, next];
        if (value === undefined) setInternal(resolved);
        onChange?.(resolved);
    }

    return (
        <div className={styles.podiumFilter}>
            {ENTRIES.map((entry, i) => {
                const isSelected = selection.includes(entry.value);
                const prevSelected = i > 0 && selection.includes(ENTRIES[i - 1].value);
                const nextSelected = i < ENTRIES.length - 1 && selection.includes(ENTRIES[i + 1].value);
                const classes = [
                    styles.entry,
                    isSelected && styles.selected,
                    isSelected && prevSelected && styles.joinLeft,
                    isSelected && nextSelected && styles.joinRight,
                ]
                    .filter(Boolean)
                    .join(' ');
                return (
                    <button
                        key={entry.value}
                        type="button"
                        className={classes}
                        onClick={() => handleClick(entry.value)}
                        aria-pressed={isSelected}
                        style={{ ['--glow-color' as keyof CSSProperties]: entry.glow } as CSSProperties}
                    >
                        <Icon variant={entry.icon} width={32} height={32} />
                    </button>
                );
            })}
        </div>
    );
}
